import { render, staticRenderFns } from "./CoverList.vue?vue&type=template&id=b15fa4aa"
import script from "./CoverList.vue?vue&type=script&lang=js"
export * from "./CoverList.vue?vue&type=script&lang=js"
import style0 from "./CoverList.vue?vue&type=style&index=0&id=b15fa4aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports